module.exports = __webpack_public_path__ + "static/media/stationary1.7f107742.jpg";